/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react"; 
import { useParams } from "react-router-dom";
import axios from 'axios';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";

import { unescapeHtml,ChangeDateStringOnlyDate } from "../../components/common/Common";

import "../../css/style.css";

const NoticeView = () => {
  const { board_idx } = useParams();
  //공지사항 
  const [varBoardData,setBoardData] = useState({});
  const [varNoticeFiles,setNoticeFiles] = useState([]);

  //공지사항정보 읽어오기
  const getNoticeList = async () => {
    const sendData = {board_idx:board_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_notice_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setBoardData(datas.results);
        if(datas.files?.length > 0) {
          setNoticeFiles(datas.files);
        }
      }
    });
  }
  //최초실행부
  useEffect(() => {
    getNoticeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  //파일 다운로드
  const onDownloadFilesHandler = (e,files) => {
    if(!window.confirm('파일을 다운로드 하시겠습니까?')) return false;
    const subFolder = files.substr(0,6);
    window.open(`${process.env.REACT_APP_PATH}/files/notice/${subFolder}/${files}`);
  }

  return (
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'공지사항 상세'}/>
        <div className="vh-content-body">
          <div className="bbs-details-wrap">
            <div className="bbs-details-head mb25">
              <div className="bbs-details-date">{ChangeDateStringOnlyDate(varBoardData.board_rdate)}</div>
              <div className="bbs-details-subject mb10">
                <p>{unescapeHtml(varBoardData.board_title)}</p>
              </div>
            </div>
            <div className="bbs-details-body">
              <div className="bbs-details-text mb20">{unescapeHtml(varBoardData.board_comment)}</div>
              {varNoticeFiles.map((files,i)=>(
                <div key={'files_'+i} style={{marginBottom:"5px",cursor:"pointer"}} onClick={e=>onDownloadFilesHandler(e,files.bp_file)}>{files.bp_name}</div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default NoticeView;